import api from "../axiosInstance";

/**
 * Fetches all withdrawal transactions (Admin only)
 * @param {Object} payload - The query parameters for filtering and pagination
 * @param {number} payload.status - Status of the transactions (1 = pending, 2 = paid)
 * @param {number} payload.page - Page number for pagination
 * @param {number} payload.limit - Number of transactions per page
 * @returns {Promise<Object>} - The response data containing all withdrawal transactions
 */
export const getAllWithdrawalTransactions = async (payload) => {
  try {
    const { status, page, limit } = payload;
    const response = await api.get(`/wallet/transactionsAll`, {
      params: { status, page, limit },
    });
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

/**
 * Marks a withdrawal transaction as paid (Admin only)
 * @param {Object} payload - The query parameters for paying a transaction
 * @param {string} payload.userId - The ID of the user whose transaction is being paid
 * @param {string} payload.userWalletTransactionInfoId - The ID of the wallet transaction to be paid
 * @returns {Promise<Object>} - The response data containing the paid transaction details
 */
export const payWithdrawalTransaction = async (payload) => {
  try {
    const { userId, userWalletTransactionInfoId } = payload;
    const response = await api.post(
      `/wallet/pay?userId=${userId}&userWalletTransactionInfoId=${userWalletTransactionInfoId}`
    );
    return response.data.data;
  } catch (err) {
    throw err;
  }
};
